export default {
  methods: {
    accessAllowed (option) {
      if (
        option.requires_subscription &&
        !this.$store.state.user.isSubscriber
      ) return false

      if (
        option.requires_pro_subscription &&
        !this.$store.state.user.isEnterpriseSubscriber &&
        !this.$store.state.user.isProSubscriber
      ) return false

      return true
    }
  }
}
